export const selectOpenSideBar = (state) => state.sideBar.currentState;